/* exported XmxCountdown */
var XmxCountdown = function($countdownElement)
{
	/**
	 * Properties
	 */
	var _deadline; // Unix Timestamp
    var _intervalHandle;

	/**
	 * Elements
	 */
    var $_countdown;
    var $_days;
    var $_hours;
    var $_minutes;
    var $_seconds;

	/**
	 * Constructor
	 */
	function boot($element)
	{
        // Hook all elements
        $_countdown = $element;
        $_days = jQuery('.xmx-countdown--days', $_countdown);
        $_hours = jQuery('.xmx-countdown--hours', $_countdown);
        $_minutes = jQuery('.xmx-countdown--minutes', $_countdown);
        $_seconds = jQuery('.xmx-countdown--seconds', $_countdown);

        // Extract the deadline
        _deadline = $_countdown.data('deadline');

        // If the deadline is 0, count down until midnight in local timezone
        if (_deadline == 0)
        {
            _deadline = new Date();
            _deadline.setHours(23, 59, 59);
            _deadline = Math.floor(_deadline.getTime() / 1000); // s
        }

        // Figure out whether to start/show the countdown
        var totalSecondsRemaining = _deadline - XmxApp.getCurrentTimestamp();

        if (totalSecondsRemaining > 0)
        {
            start();
        }
	}

    /**
     * Starts the countdown
     */
    function start()
    {
        // Update it once
        tick();

        _intervalHandle = setInterval(tick, 1000);

        $_countdown.addClass('xmx-countdown--started');
    }

    /**
     * Stops the countdown
     */
    function stop()
    {
        clearInterval(_intervalHandle);

        $_countdown.removeClass('xmx-countdown--started');
        $_countdown.addClass('xmx-countdown--expired');
    }

    /**
     * Updates things
     */
    function tick()
    {
        var currentUnixTimestamp = XmxApp.getCurrentTimestamp();
        var secondsRemaining = _deadline - currentUnixTimestamp;
        var daysRemaining;
        var hoursRemaining;
        var minutesRemaining;

        if (secondsRemaining <= 0)
        {
            stop();
        }
        else 
        {
            // Update Days
            if (secondsRemaining > 24 * 60 * 60)
            {
                daysRemaining = Math.floor(secondsRemaining / (24 * 60 * 60));
                secondsRemaining -= daysRemaining * (24 * 60 * 60);

                $_countdown.addClass('xmx-countdown--has-days');
            }
            else 
            {
                daysRemaining = 0;

                $_countdown.removeClass('xmx-countdown--has-days');
            }

            // Update Hours
            hoursRemaining = Math.floor(secondsRemaining / (60 * 60));
            secondsRemaining -= hoursRemaining * (60 * 60);

            // Update Minutes
            minutesRemaining = Math.floor(secondsRemaining / 60);
            secondsRemaining -= minutesRemaining * 60;

            // Update countdown
            $_days.html(daysRemaining < 10 ? '0' + daysRemaining : daysRemaining);
            $_hours.html(hoursRemaining < 10 ? '0' + hoursRemaining : hoursRemaining);
            $_minutes.html(minutesRemaining < 10 ? '0' + minutesRemaining : minutesRemaining);
            $_seconds.html(secondsRemaining < 10 ? '0' + secondsRemaining : secondsRemaining);
        }
    }

    // Call constructor
    boot($countdownElement);

    // Public Interface
    return {
        destroy: function()
        {
            clearInterval(_intervalHandle);
        }
    };
}
/* exported XmxNewsletterForm */
var XmxNewsletterForm = function($element) 
{
    /**
     * Properties
     */
    var _isSubmitting = false;

    /**
     * Elements
     */
    var $_form;
    var $_submitButton;
    var $_emailInput;
    var $_hashInput;
    var $_errorMessage;

    /**
     * Constructor
     */
    function boot($form) 
    {
        $_form = $form;
        $_form.on('submit', onFormSubmit);

        // Hook UI
        $_submitButton = jQuery('button[type="submit"]', $_form);
        $_emailInput = jQuery('input[name="email"]', $_form);
        $_hashInput = jQuery('input[name="date"]', $_form);
        $_errorMessage = jQuery('.xmx-form-field-message', $_form);       

        // Enable the form
        $_submitButton.prop('disabled', false);
        $_emailInput.prop('disabled', false);
    }

    /**
     * User wants to submit the form
     */
    function onFormSubmit(event)
    {
        var email;
        var validationMessage;
        var cancelSubmission;

        // Do not submit twice
        if (_isSubmitting)
        {
            cancelSubmission = true;
        }
        else 
        {
            // Check that the email address is not empty
            email = $_emailInput.val().toLowerCase().trim();
            validationMessage = XmxApp.validateEmailAddress(email);

            if (validationMessage != '')
            {
                // Validation failed
                $_errorMessage.html(validationMessage);
                $_errorMessage.addClass('xmx-form-field-message--visible');

                // Do not submit
                cancelSubmission = true;
            }
            else 
            {
                // Fill in the hash
                $_hashInput.val(XmxApp.generateHashCode(email));

                // Block clicking twice
                _isSubmitting = true;

                // Validation passed
                $_errorMessage.removeClass('xmx-form-field-message--visible');
                $_errorMessage.html('');

                // Show the ajax loader
                $_submitButton.addClass('xmx-button--loading');

                // Fire
                cancelSubmission = false;
            }
        }

        // If required, cancel the event
        if (cancelSubmission)
        {
            event.stopPropagation();
            event.preventDefault();

            return false;
        }
        else 
        {
            return true;
        }
    }

    // Call constructor
    boot($element);

    // Public Interface
    return {};
}

/* global XmxMobileHeader */
/* global XmxMobileSearch */
/* global XmxDesktopSearch */
/* global XmxCategory */

/* exported XmxToaster */
var XmxToaster = (function () 
{
    /**
     * Properties
     */
    var _sessionPageviews = 1;
    var _sessionStartAt = 0;
    var _lastToastDisplayedAt = 0;
    var _pageLoadedAt = 0;
    var _toasts = [];
    var _tickTimerHandle = null;
    var _toastCountdownTimerHandle = null;
    var _hasActiveToast = false;
    var _activeToastSecondsLeft = 0;
    var _isActiveToastExpiring = false;
    var _isActiveToastAlerting = false;
    var _activeToastIndex = null;

	 /**
	  * Elements
	  */
    var $_toastArea;
    var $_toast;
    var $_toastCountdownDigit; 
    var $_toastCircleCountdown;
    var $_powerstep;

    /**
     * 
     */
	function boot()
	{
        // If the device does not support session storage, the toaster cannot be used.
        // So lets get out of here.
        if (!XmxApp.supportsSessionStorage())
        {
            return;
        }

        // Figure out how many pageviews we have had in this session
        _sessionPageviews = XmxApp.getSessionStorageString('xmx-session-pageviews');
        _sessionStartAt = XmxApp.getSessionStorageString('xmx-session-start');
        _lastToastDisplayedAt = XmxApp.getSessionStorageString('xmx-session-toast-displayed-at');

        // Without proper session info, this cannot be used
        if (_sessionPageviews === null || _sessionStartAt === null)
        {
            //console.log('Failed to load session info - toaster wont work');
            return;
        }

        if (_lastToastDisplayedAt === null)
        {
            _lastToastDisplayedAt = 0;
        }

        // Remember when we have loaded the page (more or less)
        _pageLoadedAt = XmxApp.getCurrentTimestamp();

        // Go through all toasts and find the ones, that could potentially be displayed
        for (var toastIndex in window.naeAppConfig.toasts)
        {
            var toast = window.naeAppConfig.toasts[toastIndex];

            // Load session data
            toast.session = getToastSessionData(toast.id);

            // Can we show it? If not, we dont need to consider it while ticking
            if (canEverShowToast(toast))
            {
                _toasts.push(toast);
            }
            else 
            {
                //console.log('Can never show toast, so it is being ignored: ' + toast.title);
            }
        }

        // If there are no toasts at all, get out of here
        if (_toasts.length == 0)
        {
            //console.log('There are no toasts to show - nothing to do on this page.');
            return;
        }

        //console.log('Possible toasts:');
        //console.log(_toasts);

        // Hook things
        $_toastArea = jQuery('#xmx-toast-area');
        $_powerstep = jQuery('#powerstep');

        // Tickety tock
        startTicking();
    }

    /**
     * Start the internal ticking
     */
    function startTicking()
    {
        //console.log('Starting to tick');

        // We could make this more clever and calculate
        // when the next toast is going to be shown and wait
        // that time, instead of checking every second. 
        // But meh
        _tickTimerHandle = setInterval(tick, 1000);
    }

    /**
     * Executed every second
     */
    function tick()
    {
        // If we already have an active toast, no need to do anything here
        if (_hasActiveToast)
        {
            return;
        }

        //console.log('Ticking...');

        if (!XmxApp.isBrowserTabFocused())
        {
            //console.log('Browser tab is not visible. Not showing toasts.');
            return;
        }

        // If the mobile menu is open, dont show toasts
        if (typeof XmxMobileHeader !== 'undefined')
        {
            if (XmxMobileHeader.isOpen())
            {
                //console.log('Mobile menu is open. Not showing toasts.');
                return;
            }
        }

        // If the mobile search is open, dont show toasts
        if (typeof XmxMobileSearch !== 'undefined')
        {
            if (XmxMobileSearch.isOpen())
            {
                //console.log('Mobile search is open. Not showing toasts.');
                return;
            }
        }

        // If the desktop search is open, dont show toasts
        if (typeof XmxDesktopSearch !== 'undefined')
        {
            if (XmxDesktopSearch.isOpen())
            {
                //console.log('Desktop search is open. Not showing toasts.');
                return;
            }
        }

        // If the category filter drawer is open, dont show toasts
        if (typeof XmxCategory !== 'undefined')
        {
            if (XmxCategory.isFilterDrawedOpen())
            {
                //console.log('Filter drawer is open. Not showing toasts.');
                return;
            }
        }

        if ($_powerstep.hasClass('xmx-powerstep--visible'))
        {
            //console.log('Powerstep is open. Not showin toasts.');
            return;
        }

        // Go through all toasts and show the first one possible
        for (var toastIndex in _toasts)
        {
            if (canShowToastNow(toastIndex))
            {
                showToast(toastIndex);
                break;
            }
        }
    }

    /**
     * Shows a tast
     * 
     * @param {int} toastIndex
     */
    function showToast(toastIndex)
    {
        var now = XmxApp.getCurrentTimestamp();

        //console.log('Showing toast ' + _toasts[toastIndex].title);     

        // Stop ticking every second checking all toasts
        clearTimeout(_tickTimerHandle);

        // Remember this index is active
        _activeToastIndex = toastIndex;
        _hasActiveToast = true;
        _activeToastSecondsLeft = 20;
        _isActiveToastExpiring = false;
        _isActiveToastAlerting = false;
        _lastToastDisplayedAt = now;

        // Remember in session that it was displayed
        _toasts[_activeToastIndex].session.displays++;
        _toasts[_activeToastIndex].session.lastDisplayedAt = now;

        // Save display in session storage
        saveToastSessionData(_activeToastIndex);

        // Save the time we have seen a toast the last time
        XmxApp.setSessionStorageString('xmx-session-toast-displayed-at', now);

        // Send Internal Promotion impression to Google Analytics
        if (typeof ga != 'undefined')
        {
            // Tell Google about the impression
            ga('ec:addPromo',
            {
                'id': 'toast-' + _toasts[_activeToastIndex].id,
                'name': 'Toast: ' + _toasts[_activeToastIndex].name
            });

            ga('send', 'event',
            {
                'eventCategory': 'Toast',
                'eventAction': 'Displayed Toast',
                'eventLabel': _toasts[_activeToastIndex].name,
                'nonInteraction': true // do not affect bounce rate
            });
        }

        // Render Toast
        renderActiveToast();

        // Start the toast countdown
        _toastCountdownTimerHandle = setInterval(onActiveToastTimerTick, 1000);
    }

    /**
     * The active toast was clicked
     * 
     * @param {event} event 
     */
    function onActiveToastClick(event)
    {
        //console.log('Active Toast was clicked! Yay!');

        // Stop the toast timer
        clearTimeout(_toastCountdownTimerHandle);

        // Remember in session that this toast was clicked
        _toasts[_activeToastIndex].session.clicked = true;

        saveToastSessionData(_activeToastIndex);

        // Hide the toast
        $_toast.removeClass('xmx-toast--visible');

        // Wait for the toast to move away, then forget about it
        setTimeout(function()
        {
            //console.log('Toast removed');

            $_toast.remove();
        }, 500);

        // Send Internal Promotion impression to Google Analytics
        if (typeof ga != 'undefined')
        {
            // If Google Tracking fucks up, still submit it
            var actionExecuted = false;
            var link = _toasts[_activeToastIndex].link;

            // Make the browser open the link in max. 1 second, if the hit callback of Google analytics is not there
            var eventTrackTimeoutHandle = setTimeout
            (
                function ()
                {
                    if (!actionExecuted)
                    {
                        // Prevent executing the action twice
                        actionExecuted = true;

                        // Forward the user
                        window.location = link;
                    }
                },
                1000
            );

            // Tell Google about the click
            ga('ec:addPromo',
            {
                'id': 'toast-' + _toasts[_activeToastIndex].id,
                'name': 'Toast: ' + _toasts[_activeToastIndex].name
            });

            ga('ec:setAction', 'promo_click');

            ga('send', 'event',
            {
                'eventCategory': 'Toast',
                'eventAction': 'Clicked Toast',
                'eventLabel': _toasts[_activeToastIndex].name,
                'nonInteraction': false,
                'hitCallback': function()
                {
                    if (!actionExecuted)
                    {
                        // Do not execute twice
                        actionExecuted = true;

                        // Cancel timeout
                        clearTimeout(eventTrackTimeoutHandle);

                        // Forward the user
                        window.location = link;
                    }
                }
            });

            // Cancel the event
            event.stopPropagation();
            event.preventDefault();

            return false;
        }
    }

    /**
     * Renders the HTML of the active toast
     */
    function renderActiveToast()
    {
        var toast = _toasts[_activeToastIndex];

        // Create the toast
        $_toast = jQuery('<a>');
        $_toast.addClass('xmx-toast');
        $_toast.attr('href', toast.link);
        $_toast.on('click', onActiveToastClick);

        if (toast.image != '')
        {
            var $toastImageFrame = jQuery('<div>');
            $toastImageFrame.addClass('xmx-toast-image-frame');
            $toastImageFrame.appendTo($_toast);

            var $toastImage = jQuery('<img>');
            $toastImage.addClass('xmx-toast-image');
            $toastImage.attr('width', 48);
            $toastImage.attr('height', 48);
            $toastImage.attr('src', toast.image);
            $toastImage.appendTo($toastImageFrame);
        }

        var $toastContent = jQuery('<div>');
        $toastContent.addClass('xmx-toast-content');
        $toastContent.appendTo($_toast);

        var $toastTitle = jQuery('<div>');
        $toastTitle.addClass('xmx-toast-title');
        $toastTitle.html(toast.title);
        $toastTitle.appendTo($toastContent);

        var $toastDescription = jQuery('<div>');
        $toastDescription.addClass('xmx-toast-description');
        $toastDescription.html(toast.description);
        $toastDescription.appendTo($toastContent);

        var $toastCountdown = jQuery('<div>');
        $toastCountdown.addClass('xmx-toast-countdown');
        $toastCountdown.appendTo($_toast);

        $_toastCircleCountdown = jQuery('<div>');
        $_toastCircleCountdown.addClass('xmx-circle-countdown');
        $_toastCircleCountdown.appendTo($toastCountdown);

        var $toastCountdownLeft = jQuery('<div>');
        $toastCountdownLeft.addClass('xmx-circle-countdown-half');
        $toastCountdownLeft.addClass('xmx-circle-countdown-half--left');
        $toastCountdownLeft.appendTo($_toastCircleCountdown);

        var $toastCountdownRight = jQuery('<div>');
        $toastCountdownRight.addClass('xmx-circle-countdown-half');
        $toastCountdownRight.addClass('xmx-circle-countdown-half--right');
        $toastCountdownRight.appendTo($_toastCircleCountdown);

        $_toastCountdownDigit = jQuery('<div>');
        $_toastCountdownDigit.addClass('xmx-circle-countdown-digit');
        $_toastCountdownDigit.appendTo($_toastCircleCountdown);

        if (toast.image != '')
        {
            if (toast.badge != '')
            {
                var $badge = jQuery('<div>');
                $badge.addClass('xmx-badge');
                $badge.addClass('xmx-badge--special');
                $badge.html(toast.badge);
                $badge.appendTo($_toast);
            }
        }

        //console.log('Toast:');
        //console.log($_toast);

        //console.log('Area:');
        //console.log($_toastArea);

        // Show the toast
        $_toast.appendTo($_toastArea);
        $_toast.offset(); // Flush css

        // Move it in
        $_toast.addClass('xmx-toast--visible');

        // Start circle countdown
        $_toastCircleCountdown.addClass('xmx-circle-countdown--running');
    }

    /**
     * Invoked every second when a toast is shown
     */
    function onActiveToastTimerTick()
    {
        //console.log('Toast Timer ticking...');

        if (!XmxApp.isBrowserTabFocused())
        {
            //console.log('Browser tab is not visible. Pausing toast countdown.');
            return;
        }

        _activeToastSecondsLeft--;

        if (_activeToastSecondsLeft < 10)
        {
            if (!_isActiveToastExpiring)
            {
                $_toastCircleCountdown.addClass('xmx-circle-countdown--expiring');
                _isActiveToastExpiring = true;

                //console.log('Toast expiring soon...');
            }

            if (_activeToastSecondsLeft == 5)
            {
                if (!_isActiveToastAlerting)
                {
                    $_toastCircleCountdown.addClass('xmx-circle-countdown--alert');
                    _isActiveToastAlerting = true;

                    //console.log('Toast is alerting now...');
                }
            }

            $_toastCountdownDigit.html(_activeToastSecondsLeft);

            if (_activeToastSecondsLeft == 0)
            {
                onActiveToastTimerExpired();
            }
        }
    }

    /**
     * Invoked when the toast was not clicked within 20 seconds
     */
    function onActiveToastTimerExpired()
    {
        //console.log('Toast expired');
       
        // Stop the countdown
        clearInterval(_toastCountdownTimerHandle);

        // Remember when we have had a toast on screen
        _lastToastDisplayedAt = XmxApp.getCurrentTimestamp();

        XmxApp.setSessionStorageString('xmx-session-toast-displayed-at', _lastToastDisplayedAt);

        // Hide the toast
        $_toast.removeClass('xmx-toast--visible');

        // Wait for the toast to move away, then forget about it
        setTimeout(function()
        {
            //console.log('Toast removed');

            $_toast.remove();

            $_toast = null;
            $_toastCircleCountdown = null;
            $_toastCountdownDigit = null;

            if (_toasts[_activeToastIndex].session.displays >= _toasts[_activeToastIndex].maximumDisplayCount)
            {
                //console.log('Remoing toast from stack, as it wont show up anymore.');
                _toasts.splice(_activeToastIndex, 1);
            }

            _hasActiveToast = false;
            _activeToastIndex = null;
            
            // Start ticking again, if there are toasts
            if (_toasts.length > 0)
            {
                startTicking();
            }
            //else 
            //{
            //    //console.log('Stopped ticking forever, as there are no toasts anymore.');
            //}
        }, 500);
    }

    /**
     * Returns the toast session data loaded from session storage
     * 
     * @param {int} toastId
     * @return {object}
     */
    function getToastSessionData(toastId)
    {
        var sessionData = XmxApp.getSessionStorageJSON('xmx-session-toast-' + toastId);

        if (sessionData === null)
        {
            sessionData = 
            {
                'clicked': false,
                'displays': 0,
                'lastDisplayedAt': 0
            };
        }

        return sessionData;
    }

    /**
     * Saves the session data of a toast in the session storage of the browser
     * 
     * @param {int} toastIndex
     */
    function saveToastSessionData(toastIndex)
    {
        XmxApp.setSessionStorageJSON('xmx-session-toast-' + _toasts[toastIndex].id, _toasts[toastIndex].session);
    }

    /**
     * Returns true if a toast can ever be displayed
     * 
     * @param {object} toast 
     * @return {bool}
     */
    function canEverShowToast(toast)
    {       
        //console.log('Checking toast: ' + toast.title);

        // If the toast was clicked already, never show it again
        if (toast.session.clicked)
        {
            //console.log('Toast was already clicked');
            return false;
        }

        // If the toast was ignored too many times, never show it again
        if (toast.session.displays >= toast.maximumDisplayCount)
        {
            //console.log('Toast was already displayed ' + toast.session.displays + ' out of ' + toast.maximumDisplayCount + ' times');
            return false;
        }

        // Must have had a certain number of pageviews to display this toast
        if (_sessionPageviews < toast.minimumPageviews)
        {
            //console.log('Session did not have ' + toast.minimumPageviews + ' pageviews yet');

            return false;
        }

        // If the toast only shows until 20:00 and it is 20:15 already,
        // this toast will never be displayed
        if (toast.toTime > 0)
        {
            if (_pageLoadedAt > toast.toTime)
            {
                //console.log('It is too late to display this toast');

                return false;
            }
        }

        // Should only show on given devices
        if (XmxApp.isDesktop())
        {
            if (!toast.showOnDesktop)
            {
                //console.log('Toast should not display on desktops');
                return false;
            }
        }
        else 
        {
            if (!toast.showOnMobile)
            {
                //console.log('Toast should not display on mobiles');
                return false;
            }
        }

        // If the shopping cart does not contain any item of an included attribute set,
        // get out of here
        if (toast.includedAttributeSetIds.length > 0)
        {
            if (!findAttributeSetIdInShoppingCart(toast.includedAttributeSetIds))
            {
                return false;
            }
        }

        // If the shopping cart contains any item of an excluded attribute set,
        // get out of here
        if (toast.excludedAttributeSetIds.length > 0)
        {
            if (findAttributeSetIdInShoppingCart(toast.excludedAttributeSetIds))
            {
                return false;
            }
        }

        return true;
    }

    /**
     * Returns true if the shopping cart contains any of a list of attribute set ids
     * 
     * @param {array} attributeSetIds 
     * @return bool
     */
    function findAttributeSetIdInShoppingCart(attributeSetIds)
    {
        var foundAnyAttributeSetId = false;

        for (var attributeSetIndex in attributeSetIds)
        {
            var attributeSetId = attributeSetIds[attributeSetIndex];

            for (var itemIndex in window.naeShoppingCart.items)
            {
                var item = window.naeShoppingCart.items[itemIndex];

                if (item.attributeSetId == attributeSetId)
                {
                    foundAnyAttributeSetId = true;
                    break;
                }
            }

            if (foundAnyAttributeSetId)
            {
                break;
            }
        }

        return foundAnyAttributeSetId;
    }

    /**
     * Returns true if a toast could be shown
     * 
     * @param {int} toastIndex
     * @return bool
     */
    function canShowToastNow(toastIndex)
    {
        var toast = _toasts[toastIndex];
        var currentTimestamp = XmxApp.getCurrentTimestamp();

        // 30 seconds must pass between Toasts displays
        if (currentTimestamp - _lastToastDisplayedAt < 30)
        {
            return false;
        }

        // If the toast was clicked already, never show it again
        if (toast.session.clicked)
        {
            return false;
        }

        // Session Time
        if (toast.minimumSessionTime > 0)
        {
            if (currentTimestamp - _sessionStartAt < toast.minimumSessionTime)
            {
                return false;
            }
        }

        // Time on Page
        if (toast.minimumTimeOnPage > 0)
        {
            if (currentTimestamp - _pageLoadedAt < toast.minimumTimeOnPage)
            {
                return false;
            }
        }

        // Start Time
        if (toast.fromTime > 0)
        {
            // If it is too early to show the toast, dont show it
            if (currentTimestamp < toast.fromTime)
            {
                return false;
            }
        }

        // End Time
        if (toast.toTime > 0)
        {
            // If it is too late to show the toast, dont show it.
            // TODO: Could potentially remove the toast from the internal
            // list, because it will never be shown anymore and we 
            // dont have to check it ever again.
            if (currentTimestamp > toast.toTime)
            {
                return false;
            }
        }

        // If the toast was ignored too many times, never show it again
        if (toast.session.displays >= toast.session.maximumDisplayCount)
        {
            return false;
        }

        // Display Delay. If it was displayed already, wait some time before
        // showing it again
        if (toast.session.lastDisplayedAt > 0)
        {
            if (currentTimestamp < toast.session.lastDisplayedAt + toast.displayDelay)
            {
                return false;
            }
        }

        return true;
    }

    /**
     * Public interface
     */
    return { // line break is not allowed here

        /**
         * Constructor, boots the checkout
         */
        initialize: function() 
        {
       		boot();
        }
    };
})();


var XmxApp = 
{
    // Props
    scrollOffsetY: 0,
    scrollEventObservers: {},
    isDesktopDevice: null,
    isPhoneDevice: null,
    scope: null,

    /**
     * Initializes the app. How fancy that sounds.. :)
     */
    initialize: function()
    {
        this.determineScope();
        this.registerSessionStats();
        this.onPageLoaded();
    },

    /**
     * Keeps Session stats in the session storage
     */
    registerSessionStats: function()
    {
        if (this.supportsSessionStorage())
        {
            // Remember session start time
            var startTime = this.getSessionStorageString('xmx-session-start');

            if (startTime === null)
            {
                this.setSessionStorageString('xmx-session-start', this.getCurrentTimestamp());
            }

            // Remember pageview count
            var pageviews = this.getSessionStorageString('xmx-session-pageviews');

            if (pageviews === null)
            {
                pageviews = 1;
            }
            else 
            {
                pageviews++;
            }

            this.setSessionStorageString('xmx-session-pageviews', pageviews);

            // If this visitor is coming from Adwords, remember that
            var googleClickId = this.extractHttpGetParameter('gclid');

            if (googleClickId != '')
            {
                this.setSessionStorageString('xmx-gclid', googleClickId);
            }
        }
    },

    /**
     * Returns true if the visitor is coming from Google Adwords
     * @returns bool
     */
    isComingFromGoogleAdwords: function()
    {
        if (this.supportsSessionStorage())
        {
            return this.getSessionStorageString('xmx-gclid') !== null;
        }

        return false;
    },

    /**
     * Fired after the page has loaded
     */
    onPageLoaded: function()
    {
        var me = this;

        // Hok scrolling (causes reflow)
        this.hookScrolling();

        // Boot all videos
        jQuery('[data-video="true"]').each(function()
        {
            me.bootVideo(jQuery(this));
        });

        // Boot all carousels, if on desktop
        if (this.isDesktop())
        {
            jQuery('[data-carousel="true"]').each(function()
            {
                me.initializeSwiper(this.id);
            });
        }

        // Boot all countdowns
        jQuery('[data-countdown="true"]').each(function()
        {
            /*global XmxCountdown*/
            new XmxCountdown(jQuery(this));
        });

        // Boot all newsletter forms
        jQuery('form[data-newsletter-form="true"]').each(function()
        {
            /*global XmxNewsletterForm*/
            new XmxNewsletterForm(jQuery(this));
        });

        // Start the toaster
        /*global XmxToaster*/
        XmxToaster.initialize();

        // Run Klaviyo and Partner Ad catchers to set cookies
        this.runKlaviyoEmailCatcher();
        this.runPartnerAdsCatcher();
        this.runAdrecordCookieCatcher();
    },

    /**
     * Boots a video
     * 
     * @param {} $video 
     */
    bootVideo: function($placeholder)
    {
        var videoSource = '';
        var $container = $placeholder.parent();
        var videoClass = $placeholder.data('class');
        var videoType = $placeholder.data('type');

        if (this.isPhone())
        {
            videoSource = $placeholder.data('portrait');
        }
        else 
        {
            videoSource = $placeholder.data('landscape');
        }

        var $video = jQuery('<video>');
        $video.attr('preload', 'auto');
        $video.attr('loop', 'true');
        $video.attr('muted', 'true');
        $video.attr('autoplay', 'true');
        $video.attr('playsinline', 'true');
        $video.addClass(videoClass);

        var $source = jQuery('<source>');
        $source.attr('src', videoSource);
        $source.attr('type', videoType);
        $source.appendTo($video);

        $placeholder.remove();
        $video.appendTo($container);

        // Ensure autoplay works
        var video = $video[0];

        video.addEventListener('loadedmetadata', function()
        {
            video.muted = true; // since Chrome is stupid AF and ignores the added tags above
            video.play();
        });

        /*video.oncanplay = function()
        {
            video.muted = true; // since Chrome is stupid AF and ignores the added tags above
            video.play();
        };*/
    },

    /**
     * Partner Ads
     */
    runPartnerAdsCatcher: function()
    {
        var affiliateId = this.extractHttpGetParameter('paid');
        var clickId = this.extractHttpGetParameter('pacid');

        if (affiliateId != '' && clickId)
        {
            // Also need to store the clients IP address. God knows why,
            // but JS does not know that. If at all, it can only know
            // the local IP. So we have to do it server-side... ouch
            jQuery.ajax
            ({
                url: '/ajax/ad/partnerad',
                dataType: 'json',
                type: 'post',
                data:
                {
                    'paid': affiliateId,
                    'pacid': clickId
                }
            });
        }
    },

    runAdrecordCookieCatcher: function()
    {
        var parameter = this.extractHttpGetParameter('trackID');

        if (parameter != '')
        {
            this.setCookie('trackID', parameter, 45);
        }
    },

    runKlaviyoEmailCatcher: function()
    {
        var parameter = this.extractHttpGetParameter('_ke');

        if (parameter != '')
        {
            if (typeof atob !== 'undefined')
            {
                var data = JSON.parse(atob(parameter));

                if (typeof data !== 'undefined')
                {
                    if (typeof data.kl_email !== 'undefined')
                    {
                        this.setCookie('mshop-email', data.kl_email, 365);
                        
                        var clerkVisitorId = this.getLocalStorageString('clerk-visitor-id');
                        
                        if (clerkVisitorId)
                        {
                            clerkVisitorId = clerkVisitorId.substr(1, clerkVisitorId.length - 2);

                            if (window.naeAppConfig.clerkApiKey != '')
                            {
                                var postData =
                                {
                                    'key': window.naeAppConfig.clerkApiKey,
                                    'email': data.kl_email,
                                    'visitor': clerkVisitorId
                                };

                                // Fire and forget
                                jQuery.ajax
                                ({
                                    url: 'https://api.clerk.io/v2/log/email',
                                    dataType: 'json',
                                    type: 'get',
                                    data: postData
                                });
                            }
                        }
                    }
                }
            }
        }
    },

    /**
     * Counts a certain character within a string
     * (Cannot believe I had to code this)
     *
     * @param string string
     * @param char character
     * @param string
     */
    countCharacter: function (string, character) 
    {
        var count = 0;

        for (var i = 0; i < string.length; i++) 
        {
            if (string[i] == character) 
            {
                count++;
            }
        }

        return count;
    },

    /**
     * A VERY simple checksum of the email
     */
    generateHashCode: function(input) 
    {
        var checksum = 0;
        var length = input.length;
        var i;

        for (i = 0; i < length; i++) 
        {
            checksum = (checksum + input.charCodeAt(i)) % 10000;
        }

        return checksum;
    },

    /**
     * Validates an email address.
     *
     * @param string value
     * @param string
     */
    validateEmailAddress: function (value)
    {
        var emailRegex;
        var parts;

        // Check only lower case
        value = value.toLowerCase();

        // Must not be empty
        value = value.trim();

        if (value.length == 0)
        {
            return window.naeAppConfig.i18n.enterEmail; // PASS
        }

        // Must contain @
        if (value.indexOf('@') == -1)
        {
            return window.naeAppConfig.i18n.enterAtSymbol; // PASS
        }

        // Must contain only one @
        if (this.countCharacter(value, '@') > 1)
        {
            return window.naeAppConfig.i18n.enterOnlyOneAt; // PASS
        }

        // Split at the @ symbol
        parts = value.split('@', 2);

        // Check part to the left
        parts[0] = parts[0].trim();

        if (parts[0] == '')
        {
            return window.naeAppConfig.i18n.enterBeforeAt; // PASS
        }

        // Check part to the right
        parts[1] = parts[1].trim();

        if (parts[1] == '')
        {
            return window.naeAppConfig.i18n.enterAfterAt; // PASS
        }

        // Ensure right part has at least one dot
        if (parts[1].indexOf('.') == -1)
        {
            return window.naeAppConfig.i18n.enterValidDomain; // PASS
        }

        // Not used: RFC 2822 (a.d. 2001, https://www.ietf.org/rfc/rfc2822.txt)
        // Used: RFC 5322 (a.d. 2008, https://www.ietf.org/rfc/rfc5322.txt)
        // This even works with umlaut domains
        // Does not work for email@localhost, so it would not work
        // in an intranet
        emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!emailRegex.test(value))
        {
            return window.naeAppConfig.i18n.enterValidEmail; // PASS
        }

        return '';
    },

    /**
     * Finds out in which scope we currently are
     */
    determineScope: function()
    {
        var cookieValue = this.getCookie('mshop-scope');

        if (cookieValue)
        {
            this.scope = cookieValue;
        }
        else 
        {
            // TODO: Grab scope from the DOM

            // Otherwise default to couples
            this.setScope('couples');
        }
    },

    /**
     * Sets the current scope
     * 
     * @param {string} scopeName 
     */
    setScope: function(scopeName)
    {
        this.scope = scopeName;

        this.setCookie('mshop-scope', this.scope, 365);
    },

    /**
     * Gets the current Unix Timestamp in seconds
     */
    getCurrentTimestamp: function()
    {
        var currentTimestamp = new Date().getTime(); // ms

        return Math.floor(currentTimestamp / 1000); // s
    },

    /**
     * Registers a new event observer for the window.onscroll event
     * 
     * @param {string} id A unique ID for this event observer
     * @param {function} callback The callback to call when a scroll happens. Called inside an animation frame where supported
     */
    registerScrollEventObserver: function(id, callback)
    {
        this.scrollEventObservers[id] = callback;
    },

    /**
     * Removes a scroll event observer
     * 
     * @param {string} id The ID of the event observer
     */
    unregisterScrollEventObserver: function(id)
    {
        delete this.scrollEventObservers[id];
    },

    /**
     * Calls all scroll event observers
     */
    emitScrollEvent: function()
    {
        // Could only emit this if there is at least one event observer, but we know there 
        // is always gonna be two at least (desktop menu + mobile menu)

        // Triggers reflow/layout
        this.scrollOffsetY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

        for (var id in this.scrollEventObservers)
        {
            this.scrollEventObservers[id]();
        }
    },

    /**
     * Hooks the window.onscroll event and dispatches it properly to all event observers, so we dont
     * have to trigger layout reflow multiple times
     */
    hookScrolling: function()
    {
        var waiting = false;
        var hasChangedScrollPosition = false;
        var self = this;

        document.addEventListener('scroll', function()
        {
            hasChangedScrollPosition = true;

            if (!waiting)
            {
                waiting = true;

                // Where supported, fire this each frame ... ugh
                if (window.requestAnimationFrame)
                {
                    window.requestAnimationFrame(function()
                    {
                        self.emitScrollEvent();
                        waiting = false;
                        hasChangedScrollPosition = false;
                    });
                }
                else 
                {
                    // If not, throttle down to 100ms/event
                    self.emitScrollEvent();
                    hasChangedScrollPosition = false;

                    setTimeout(function()
                    {
                        // Fire again if we have scrolled within the 100ms waiting period
                        if (hasChangedScrollPosition)
                        {
                            self.emitScrollEvent();
                        }

                        waiting = false;
                        hasChangedScrollPosition = false;
                    }, 100);
                }
            }
        });

        // TODO: This is causing a reflow during page load, which is not great
        // Fetch the scroll position once, so we can get it when the page loaded (in case we landed further down)
        this.scrollOffsetY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    },

    /**
     * "100 ml" or "249 kr" or "19,95 €"
     * 
     * @param {string} amount 
     * @param {string} unit 
     */
    formatUnit: function(amount, unit)
    {
        /*
            Because Javascript and its floating point precision...

            29.49 - 29.00 = 0.48999999999999844
            18.99 - 3 = 15.989999999999998

            .. we hav to do it the ultra dirty way
         */
        var integer = parseInt(amount);
        var parts = amount.toFixed(2).toString().split('.');
        var decimals = parts.length == 2 ? parts[1] : '00';

        if (decimals == '00')
        {
            return (integer + ' ' + unit);
        }
        else 
        {
            return (integer + window.naeAppConfig.decimalSeparator + decimals + ' ' + unit);
        }
    },

    /**
     * "199 kr" or "19,95 €"
     * 
     * @param {string} amount 
     */
    formatAmount: function(amount)
    {
        return this.formatUnit(amount, window.naeAppConfig.currencySymbol); // perfectly fine for mshop
    },

    /**
     * mshop.se: 199:-
     * mshop.dk: 199,-
     * mshop.eu: 199.-
     * 
     * @param {string} amount 
     */
    formatPrice: function(amount)
    {
        var integer = parseInt(amount);
        var parts = amount.toFixed(2).toString().split('.');
        var decimals = parts.length == 2 ? parts[1] : '00';

        if (decimals == '00')
        {
            decimals = '-';
        }

        return (integer + window.naeAppConfig.decimalSeparatorPrice + decimals);
    },

    /**
     * Returns the value of an HTTP GET parameter or ''
     * 
     * @param {string} parameterName 
     */
	extractHttpGetParameter: function(parameterName)
	{
		var parameters = window.location.search.substring(1).split('&');
		var parameterParts;

		for (var i = 0; i < parameters.length; i++)
		{
			parameterParts = parameters[i].split('=');

			if (parameterParts.length == 2)
			{
				if (parameterParts[0] == parameterName)
				{
                    return decodeURIComponent(parameterParts[1]);
				}
			}
		}

		return '';
	},

    /**
     * Fires and forgets a Google Analytics event
     * 
     * @param {string} category 
     * @param {string} action 
     * @param {string} label 
     * @param {bool} nonInteraction 
     */
    sendGoogleAnalyticsEvent: function(category, action, label, nonInteraction)
    {
        if (typeof ga !== 'undefined')
        {
            ga('send', 'event', 
            {
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label, 
                'nonInteraction': nonInteraction
            });
        }
    },

    /**
     * Sends a Google Analytics event and calls a callback afterwards
     * 
     * @param {string} category 
     * @param {string} action 
     * @param {string} label 
     * @param {bool} nonInteraction 
     * @param {function} callback
     * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits
     */
    sendGoogleAnalyticsEventWithCallback: function(category, action, label, nonInteraction, callback)
    {
        if (typeof ga !== 'undefined')
        {
            var callbackFired = false;
            var callbackTimeoutHandle = null;

            // Gets called either by ga() or setTimeout()
            function fireCallback()
            {
                if (!callbackFired) // Prevent firing the callback twice
                {
                    callbackFired = true;

                    if (callbackTimeoutHandle !== null)
                    {
                        clearTimeout(callbackTimeoutHandle);
                    }

                    callback();
                }
            }

            // If the hitCallback of GUA does not fire within a second,
            // ensure the callback gets called anyways
            callbackTimeoutHandle = setTimeout(fireCallback, 1000);

            // Tell Google
            ga('send', 'event', 
            {
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label, 
                'nonInteraction': nonInteraction,
                'hitCallback': fireCallback
            });
        }
        else 
        {
            callback();
        }
    },

    /**
     * Initializes Swiper, so that a carousel works on desktops
     * 
     * @param {string} elementId 
     */
    initializeSwiper: function(elementId)
    {
        if (!this.isDesktop())
        {
            return;
        }

        new Swiper('#' + elementId, 
        {
            containerModifierClass: 'xmx-carousel-container--',
            wrapperClass: 'xmx-carousel-elements',
            slideClass: 'xmx-carousel-element',
            slideActiveClass: 'xmx-carousel-element--active',
            slideVisibleClass: 'xmx-carousel-element--visible',
            slidePrevClass: 'xmx-carousel-element--previous',
            slideNextClass: 'xmx-carousel-element--next',

            slidesPerView: 'auto',
            spaceBetween: 0,
            simulateTouch: true,
            threshold: 0,
            grabCursor: false,
            pagination:
            {
                el: '#' + elementId + '-pagination',
                clickable: true,
                bulletClass: 'xmx-carousel-pagination-bullet',
                bulletActiveClass: 'xmx-carousel-pagination-bullet--active'
            },
            navigation:
            {
                nextEl: '#' + elementId + '-next',
                prevEl: '#' + elementId + '-previous',
                disabledClass: 'xmx-carousel-button--disabled'
            }
        });
    },

    /**
     *  Replaces all y-srcset and y-src so we can load deferred images
     * 
     * @param {object} $container 
     */
    replaceYImageSource: function($container)
    {
        jQuery('[y-srcset]', $container).each(function()
        {
            var $element = jQuery(this);
            var value = $element.attr('y-srcset');

            $element.removeAttr('y-srcset');
            $element.attr('srcset', value);
        });

        jQuery('[y-src]', $container).each(function()
        {
            var $element = jQuery(this);
            var value = $element.attr('y-src');

            $element.removeAttr('y-src');
            $element.attr('src', value);
        });
    },

    /**
     * Initializes the last viewed products (Clerk shows it even if there are no products to show)
     * @param {*} event 
     */
    initializeClerkLastViewedProducts: function(event)
    {
        var $carouselContainer = jQuery(event.target);
        var $carouselElements = jQuery('.xmx-carousel-element', $carouselContainer);

        if ($carouselElements.length > 0)
        {
            var $section = jQuery('#last-viewed-products-section');

            this.replaceYImageSource($carouselContainer);

            $section.show();
        }
    },

    /**
     * Intializes a Clerk Swiper (only on Desktops)
     */
	initializeClerkSwiper: function(event)
	{
        // Until we use Clerk 2.0 where it is fixed. They have a problem in Clerk 1.0 where 
        // the attribute is first added to the DOM and then placeholders inside it are replaced.
        // We use the <picture> element with <source> elements which have a "srcset" attribute.
        // The second the browser sees that in the DOM it will try to download the images, but these
        // attributes are still the placeholders of the Clerk template, thus the browser will not
        // download the right <source> and will fall back to the default <img>, rendering the <picture>
        // element effectless. Also, it will spam the console with thousands of lines.
        //
        // A way around this (for Clerk 1.0) is to have Clerk add the attribute as "XYZ-srcset" and then
        // rename them to "srcset" later on... how silly
        var $swiperWrapper = jQuery(event.target);

        this.replaceYImageSource($swiperWrapper);

        var $swiperContainer = $swiperWrapper.parent();
        var swiperId = $swiperContainer.attr('id');

        this.initializeSwiper(swiperId);
	},

    /**
     * Returns true if we are in the Desktop version of mshop.se.
     * Same as our media queries
     * 
     * @returns bool
     */
    isDesktop: function()
    {
        if (this.isDesktopDevice === null)
        {
            if (this.supportsMediaQueries())
            {
                this.isDesktopDevice = this.matchMediaQuery('(min-width: 1280px)');
            }
            else 
            {
                // Fallback
                this.isDesktopDevice = screen.width >= 1280;
            }
        }

        return this.isDesktopDevice; 
    },

    /**
     * Returns true if the current tab is visible
     */
    isBrowserTabFocused: function()
    {
        // Current API
        if (typeof document.visibilityState !== 'undefined')
        {
            return document.visibilityState == 'visible';
        }

        // Old API
        if (typeof document.hidden !== 'undefined')
        {
            return !document.hidden;
        }

        return true;
    },

    /**
     * Returns true if we are in the phone version of mshop.se.
     * Same as our media queries
     * 
     * @returns bool
     */
    isPhone: function()
    {
        if (this.isPhoneDevice === null)
        {
            if (this.supportsMediaQueries())
            {
                this.isPhoneDevice = this.matchMediaQuery('(max-width: 767px)');
            }
            else 
            {
                // Fallback
                this.isPhoneDevice = screen.width <= 767;
            }
        }

        return this.isPhoneDevice; 
    },

    /**
     * Downloads an image, so that the browser has it in the cache.
     * 
     * @param {string} uri 
     */
    downloadImage: function(uri)
    {
        var browserImage = new Image();
        browserImage.src = uri;
    },

    /**
     * Returns true if the browser supports media query matching
     * 
     * @return {bool}
     */
    supportsMediaQueries: function()
    {
        return typeof window.matchMedia !== 'undefined';
    },

    /**
     * Returns true if the browser supports the history API
     * 
     * @return {bool}
     */
    supportsHistoryApi: function()
    {
        return typeof window.history.replaceState !== 'undefined';
    },

    /**
     * Returns true if a media query is matched. Check that this is supported
     * before.
     * 
     * @param {string} query 
     * @return {bool}
     */
    matchMediaQuery: function(query)
    {
        return window.matchMedia(query).matches;
    },

    /**
     * Returns true if the browser supports session storage
     * 
     * @return {bool}
     */
    supportsSessionStorage: function()
    {
        var isSupported = false;

        /**
         * Some browsers throw this in incognito mode:
         * 
         * Error: Failed to read the 'sessionStorage' property 
         * from 'Window':Access is denied for this document.
         */
        try 
        {
            isSupported = typeof(window.sessionStorage) !== 'undefined';
        }
        catch (error) 
        {
            isSupported = false;
        }

        return isSupported;
    },

    /**
     * Returns true if the browser supports local storage
     * 
     * @return {bool}
     */
    supportsLocalStorage: function()
    {
        var isSupported = false;

        /**
         * Some browsers throw this in incognito mode:
         * 
         * Error: Failed to read the 'localStorage' property
         * from 'Window':Access is denied for this document.
         */
        try 
        {
            isSupported = typeof (window.localStorage) !== 'undefined';
        }
        catch (error) 
        {
            isSupported = false;
        }

        return isSupported;
    },

    /**
     * Returns true if Clerk is loaded
     * 
     * @return {bool}
     */
    supportsClerk: function()
    {
        return typeof(window.Clerk) !== 'undefined'
    },

    /**
     * Saves a string in the session storage
     * 
     * @param {string} key 
     * @param {string} value 
     */
    setSessionStorageString: function(key, value)
    {
        // Safari 10.3.3 will just use a quota of 0 in private mode
        try 
        {
            window.sessionStorage.setItem(key, value);
        }
        catch (error) 
        {
            // QuotaExceededError. Comment must be here, because ES Lint
        }
    },

    /**
     * Returns a string stored in the session storage or null
     * 
     * @param {string} key 
     * @return {null|string}
     */
    getSessionStorageString: function(key)
    {
        return window.sessionStorage.getItem(key);
    },

    /**
     * Kills a session storage entry with fire
     * 
     * @param {string} key 
     */
    clearSessionStorage: function(key)
    {
        window.sessionStorage.removeItem(key);
    },

    /**
     * Saves an object in the session storage
     * 
     * @param {string} key 
     * @param {any} value 
     */
    setSessionStorageJSON: function(key, value)
    {
        this.setSessionStorageString(key, JSON.stringify(value));
    },

    /**
     * Returns data stored in the session storage in JSON format or null
     * 
     * @param {string} key 
     * @return {null|any}
     */
    getSessionStorageJSON: function(key)
    {
        var value = this.getSessionStorageString(key);
        var result = null;

        if (value)
        {
            try 
            {
                value = JSON.parse(value);

                if (value)
                {
                    result = value;
                }
            }
            catch (error) // SyntaxError
            {
                result = null;
            }
        }

        return result;
    },
 
    /**
     * Saves a string in the local storage
     * 
     * @param {string} key 
     * @param {string} value 
     */
    setLocalStorageString: function(key, value)
    {
        // Safari 10.3.3 will just use a quota of 0 in private mode
        try 
        {
            window.localStorage.setItem(key, value);
        }
        catch (error)
        {
            // QuotaExceededError. Comment must be here, because ES Lint
        }
    },

    /**
     * Returns a string stored in the local storage or null
     * 
     * @param {string} key 
     * @return {null|string}
     */
    getLocalStorageString: function(key)
    {
        return window.localStorage.getItem(key);
    },

    /**
     * Saves an object in the local storage
     * 
     * @param {string} key 
     * @param {any} value 
     */
    setLocalStorageJSON: function(key, value)
    {
        this.setLocalStorageString(key, JSON.stringify(value));
    },

    /**
     * Returns data stored in the local storage in JSON format or null
     * 
     * @param {string} key 
     * @return {null|any}
     */
    getLocalStorageJSON: function(key)
    {
        var value = this.getLocalStorageString(key);
        var result = null;

        if (value)
        {
            try 
            {
                value = JSON.parse(value);

                if (value)
                {
                    result = value;
                }
            }
            catch (error) // SyntaxError
            {
                result = null;
            }
        }

        return result;
    },

    /**
     * Returns a cookie value or null
     * 
     * @param {null|string} name 
     */
    getCookie: function(name)
    {
        var value = null;
        var cookieParts = decodeURIComponent(document.cookie).split(';');

        for (var cookieIndex in cookieParts)
        {
            var cookiePart = cookieParts[cookieIndex];

            while (cookiePart.charAt(0) == ' ')
            {
                cookiePart = cookiePart.substring(1);
            }

            if (cookiePart.indexOf(name + '=') == 0) 
            {
                value = cookiePart.substring(name.length + 1);
                break;
            }
        }

        return value;
    },

    /**
     * Kills a cookie with fire
     * 
     * @param {string} name 
     */
    removeCookie: function(name)
    {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    },

    /**
     * Sets a cookie
     * 
     * @param {string} name Name of the cookie
     * @param {string} value Value of the cookie
     * @param {int|null} lifetime Lifetime in days or null for session cookies
     */
    setCookie: function(name, value, lifetime)
    {
        if (lifetime === null)
        {
            // Session Cookies
            document.cookie = name + "=" + value + ";path=/;samesite=None;secure;domain=" + window.naeAppConfig.cookieDomain;
        }
        else 
        {   
            // Regular Cookies
            var expirationDate = new Date();

            expirationDate.setTime(expirationDate.getTime() + (lifetime * 24 * 60 * 60 * 1000));

            var expires = "expires=" + expirationDate.toUTCString();

            document.cookie = name + "=" + value + ";" + expires + ";path=/;samesite=None;secure;domain=" + window.naeAppConfig.cookieDomain;
        }
    },

    /**
     * Renders xmx-rating
     * 
     * @param {int} rating 
     * @param {int|null} count 
     * @param {element} $parent
     */
    renderRating: function(rating, count, $parent)
    {
        var $rating = jQuery('<div>');
        $rating.addClass('xmx-rating');

        for (var star = 1; star <= 5; star++)
        {
            var $star = jQuery('<div>');

            if (rating >= star)
            {
                $star.addClass('xmx-icon-star');
            }
            else 
            {
                if (rating >= star - 0.5)
                {
                    $star.addClass('xmx-icon-star-half');
                }
                else 
                {
                    $star.addClass('xmx-icon-star-empty');
                }
            }

            $star.appendTo($rating);
        }

        if (count !== null)
        {
            var $count = jQuery('<div>');
            $count.addClass('xmx-rating-reviews');
            $count.html('(' + count + ')');
            $count.appendTo($rating);
        }

        $rating.appendTo($parent);
    }
};

XmxApp.initialize();

// Since Clerk cannot call XmxApp.initializeClerkSwiper()
/* exported initializeClerkSwiper */
function initializeClerkSwiper(event)
{
    XmxApp.initializeClerkSwiper(event);
}

/* exported initializeClerkLastViewedProducts */
function initializeClerkLastViewedProducts(event)
{
    XmxApp.initializeClerkLastViewedProducts(event);
}

/* exported XmxSearch */
var XmxSearch = 
{
    searchQuery: null,
    popularSearchQueries: null,
    trendingProducts: null,
    suggestedSearchQueries: null,
    products: null,
    categories: null,
    didRestore: false,
    categoryAjaxHandle: null,

    /**
     * Peeks the search query that might be stored in the storage
     */
    peekStoredSearchQuery: function()
    {
        var query = null;

        if (XmxApp.supportsSessionStorage())
        {
            query = XmxApp.getSessionStorageString('xmx-search-query');
        }

        return query;
    },

    /**
     * Restores the state of the search from local/session storage
     */
    restoreState: function()
    {
        // Do not restore multiple times
        if (this.didRestore)
        {
            return;
        }

        // Query, Products, Suggestions and Categories are saved in session storage
        if (XmxApp.supportsSessionStorage())
        {
            this.searchQuery = XmxApp.getSessionStorageString('xmx-search-query');
            this.categories = XmxApp.getSessionStorageJSON('xmx-search-categories');
            this.suggestedSearchQueries = XmxApp.getSessionStorageJSON('xmx-search-suggestions');
            this.products = XmxApp.getSessionStorageJSON('xmx-search-products');
        }

        // Popular Queries and Trending Products are saved in local storage
        if (XmxApp.supportsLocalStorage())
        {
            var popularData = XmxApp.getLocalStorageJSON('xmx-search-popular');

            if (popularData)
            {
                // Popular Queries are valid for 6 hours. After that
                // The client should download them again
                if (XmxApp.getCurrentTimestamp() - popularData.timestamp < 60*60*6)
                {
                    this.popularSearchQueries = popularData.queries;
                }
            }

            var trendingData = XmxApp.getSessionStorageJSON('xmx-search-trending');

            if (trendingData)
            {
                // Trending Products are valid for 6 hours. After that
                // The client should download them again
                if (XmxApp.getCurrentTimestamp() - trendingData.timestamp < 60*60*6)
                {
                    this.trendingProducts = trendingData.products;
                }
            }
        }

        // Remember we have tried to restore these, so we dont do it again
        this.didRestore = true;
    },

    /**
     * Downloads suggested search queries from Clerk
     * and returns them via a callback
     * 
     * @param {string} callback
     * @param {function} callback 
     */
    fetchSuggestedSearchQueries: function(query, callback)
    {
        var me = this;

        // Cannot do this without Clerk
        if (!XmxApp.supportsClerk())
        {
            callback(null);
        }
        else 
        {
            Clerk.call
            (
                'search/suggestions',
                {
                    key: window.naeAppConfig.clerkApiKey,
                    language: window.naeAppConfig.clerkLanguage,
                    query: query,
                    limit: 6
                },
                function (response)
                { 
                    me.suggestedSearchQueries = null;

                    if (response.status == 'ok')
                    {
                        if (response.result.length > 0)
                        {
                            me.suggestedSearchQueries = response.result;
                        }
                    }

                    // Remember the suggestions in session storage
                    if (XmxApp.supportsSessionStorage())
                    {
                        XmxApp.setSessionStorageJSON('xmx-search-suggestions', me.suggestedSearchQueries);
                    }

                    callback(me.suggestedSearchQueries);
                }
            );
        }
    },

    /**
     * Downloads categories from Magento
     * and returns them via a callback
     * 
     * @param {string} callback
     * @param {function} callback 
     */
    fetchCategories: function(query, callback)
    {
        var me = this;

        // Abort AJAX stuff going on right now
        if (me.categoryAjaxHandle !== null)
        {
            me.categoryAjaxHandle.abort();
        }

        jQuery.ajax
        ({
            url: '/ajax/search/category',
            dataType: 'json',
            type: 'post',
            cache: false,
            data: 
            {
                query: query
            },
            xhr: function()
            {
                me.categoryAjaxHandle = new window.XMLHttpRequest();

                return me.categoryAjaxHandle;
            },
            success: function(response)
            {
                me.categories = null;

                if (response.success)
                {
                    if (response.categories.length > 0)
                    {
                        me.categories = response.categories;
                    }
                }

                // Remember the categories in session storage
                if (XmxApp.supportsSessionStorage())
                {
                    XmxApp.setSessionStorageJSON('xmx-search-categories', me.categories);
                }
            },
            error: function()
            {
                me.categories = null;
            },
            complete: function()
            {
                // Empty our AJAX handle, since there is nothing
                // to cancel anymore
                me.categoryAjaxHandle = null;

                callback(me.categories);
            }
        });
    },

    /**
     * Downloads products from Clerk
     * and returns them via a callback
     * 
     * @param {string} callback
     * @param {function} callback 
     */
    fetchProducts: function(query, callback)
    {
        var me = this;

        // Cannot do this without Clerk
        if (!XmxApp.supportsClerk())
        {
            callback(null);
        }
        else 
        {
            Clerk.call
            (
                'search/predictive',
                {
                    key: window.naeAppConfig.clerkApiKey,
                    language: window.naeAppConfig.clerkLanguage,
                    query: query,
                    limit: 6,
                    attributes: 
                    [
                        'id',
                        'url', 
                        'url_key',
                        'thumbnail_type', 
                        'thumbnail_cache_buster', 
                        'name',
                        'manufacturer',
                        'mshop_subtitle',
                        'mshop_type',
                        'price',
                        'special_price',
                        'is_on_sale',
                        'mshop_card_tags',
                        'mshop_primary_badge',
                        'mshop_secondary_badge',
                        'base_price_string'
                    ]
                },
                function (response)
                { 
                    me.products = null;

                    if (response.status == 'ok')
                    {
                        if (response.product_data.length > 0)
                        {
                            me.products = response.product_data;
                        }
                    }

                    // Remember the products in session storage
                    if (XmxApp.supportsSessionStorage())
                    {
                        XmxApp.setSessionStorageJSON('xmx-search-products', me.products);
                    }

                    callback(me.products);
                }
            );
        }
    },

    /**
     * Downloads popular search queries from Clerk
     * and returns them via a callback
     * 
     * @param {function} callback 
     */
    fetchPopularSearchQueries: function(callback)
    {
        var me = this;

        // Cannot do this without Clerk
        if (!XmxApp.supportsClerk())
        {
            callback(null);
        }
        else 
        {
            Clerk.call
            (
                'search/popular',
                {
                    key: window.naeAppConfig.clerkApiKey,
                    language: window.naeAppConfig.clerkLanguage,
                    limit: 10
                },
                function (response)
                { 
                    me.popularSearchQueries = null;

                    if (response.status == 'ok')
                    {
                        if (response.result.length > 0)
                        {
                            me.popularSearchQueries = response.result;
                        }
                    }

                    // Remember the popular search queries in local storage
                    if (XmxApp.supportsLocalStorage())
                    {
                        var data = 
                        {
                            timestamp: XmxApp.getCurrentTimestamp(),
                            queries: me.popularSearchQueries
                        };

                        XmxApp.setLocalStorageJSON('xmx-search-popular', data);
                    }

                    callback(me.popularSearchQueries);
                }
            );
        }
    },

    /**
     * Downloads popular search queries from Clerk
     * and returns them via a callback
     * 
     * @param {function} callback 
     */
    fetchTrendingProducts: function(callback)
    {
        var me = this;

        // Cannot do this without Clerk
        if (!XmxApp.supportsClerk())
        {
            callback(null);
        }
        else 
        {
            Clerk.call
            (
                'recommendations/trending',
                {
                    key: window.naeAppConfig.clerkApiKey,
                    limit: 6,
                    attributes: 
                    [
                        'id',
                        'url', 
                        'url_key',
                        'thumbnail_type', 
                        'thumbnail_cache_buster', 
                        'name',
                        'manufacturer',
                        'mshop_subtitle',
                        'mshop_type',
                        'price',
                        'special_price',
                        'is_on_sale',
                        'mshop_card_tags',
                        'mshop_primary_badge',
                        'mshop_secondary_badge',
                        'base_price_string'
                    ]
                },
                function (response)
                { 
                    me.trendingProducts = null;

                    if (response.status == 'ok')
                    {
                        if (response.product_data.length > 0)
                        {
                            me.trendingProducts = response.product_data;                           
                        }
                    }

                    // Remember the popular search queries in local storage
                    if (XmxApp.supportsLocalStorage())
                    {
                        var data = 
                        {
                            timestamp: XmxApp.getCurrentTimestamp(),
                            queries: me.trendingProducts
                        };

                        XmxApp.setLocalStorageJSON('xmx-search-trending', data);
                    }

                    callback(me.trendingProducts);
                }
            );
        }
    },

    /**
     * Puts the search query into session storage
     * 
     * @param {string} query 
     */
    saveSearchQuery: function(query)
    {
        this.searchQuery = query;

        if (XmxApp.supportsSessionStorage())
        {
            XmxApp.setSessionStorageString('xmx-search-query', this.searchQuery);
        }
    },

    /**
     * Throws the session storage away. Used when the user clears
     * the input field.
     */
    clearSessionStorage: function()
    {
        if (XmxApp.supportsSessionStorage())
        {
            XmxApp.clearSessionStorage('xmx-search-query');
            XmxApp.clearSessionStorage('xmx-search-suggestions');
            XmxApp.clearSessionStorage('xmx-search-categories');
            XmxApp.clearSessionStorage('xmx-search-products');
        }

        // Forget things
        this.searchQuery = null;
        this.suggestedSearchQueries = null;
        this.categories = null;
        this.products = null;
    },

    /**
     * Renders categories
     * 
     * @param {array} categories 
     * @param {element} $list 
     * @param {element} $container 
     */
    renderCategories: function(categories, $list, $container)
    {
        var $category;
        var $categoryText;
        var category;
        var categoryHtml;

        $list.empty();

        if (categories)
        {
            for (var categoryIndex in categories)
            {
                category = categories[categoryIndex];
                categoryHtml = this.highlightQuery(category.name);

                if (category.scope)
                {
                    categoryHtml += ' <sub>' + category.scope + '</sub>';
                }

                $category = jQuery('<a>');
                $category.addClass('xmx-search-text-result');
                $category.attr('href', category.url);
                $category.appendTo($list);

                $categoryText = jQuery('<span>');
                $categoryText.addClass('xmx-search-text-result-text');
                $categoryText.html(categoryHtml);
                $categoryText.appendTo($category);
            }

            $container.show();
        }
        else 
        {
            $container.hide();
        }
    },

    /**
     * Renders queries
     * 
     * @param {array} queries 
     * @param {element} $list 
     * @param {element} $container 
     * @param {bool} highlight
     * @param {string} icon
     */
    renderQueries: function(queries, $list, $container, highlight, icon)
    {
        var $query;
        var $queryText;
        var $queryIcon;
        var query;

        $list.empty();

        if (queries)
        {
            for (var queryIndex in queries)
            {
                query = queries[queryIndex];

                $query = jQuery('<a>');
                $query.addClass('xmx-search-text-result');
                $query.attr('href', '/catalogsearch/result?q=' + encodeURIComponent(query));
                $query.attr('data-selectable', true);
                $query.attr('data-query', query);
                $query.appendTo($list);

                $queryText = jQuery('<span>');
                $queryText.addClass('xmx-search-text-result-text');
                $queryText.html(highlight ? this.highlightQuery(query) : query);
                $queryText.appendTo($query);

                if (icon)
                {
                    $query.addClass('xmx-search-text-result--with-icon');

                    $queryIcon = jQuery('<span>');
                    $queryIcon.addClass('xmx-search-text-result-icon');
                    $queryIcon.addClass(icon);
                    $queryIcon.appendTo($query);
                }
            }

            $container.show();
        }
        else 
        {
            $container.hide();
        }
    },

    /**
     * Takes a phrase and highlights the difference to the current search query
     * 
     * @param {string} phrase 
     */
    highlightQuery: function(phrase)
    {
        var result = phrase;

        if (this.searchQuery)
        {
            var regex = new RegExp(this.searchQuery, 'gi');
            
            result = phrase.replace(regex, function(str) { return '<span>' + str + '</span>'});
        }

        return result;
    },

    /**
     * Creates and appends product data to a given parent node
     * 
     * @param {object} productData 
     * @param {Element} $parent 
     */
    createProductHtml: function(productData, $parent)
    {
        var elementId = 'search-product-' + productData.id;
        var $badge;
        var $badges;
        var $brand;
        var $desktopSource;
        var $discount;
        var $image;
        var $imageContainer;
        var $imageWrapper;
        var $mobileSource;
        var $name;
        var $newPrice;
        var $oldPrice;
        var $picture;
        var $price;
        var $product;
        var $regularPrice;
        var $shortDescription;
        var $tag;
        var $tags;
        var $text;
        var saving;
        var tagIndex;
        var $basePrice;

        $product = jQuery('<a>');
        $product.addClass('xmx-mini-product');
        $product.attr('href', productData.url);
        $product.attr('id', elementId);
        $product.attr('data-product-id', productData.id);
        $product.attr('data-clerk-hooked', false);

        $imageWrapper = jQuery('<div>');
        $imageWrapper.addClass('xmx-product-image');
        $imageWrapper.addClass('xmx-product-image--' + productData.thumbnail_type);
        $imageWrapper.appendTo($product);

        $imageContainer = jQuery('<div>');
        $imageContainer.addClass('xmx-product-image-regular');
        $imageContainer.appendTo($imageWrapper);

        $picture = jQuery('<picture>');
        $picture.appendTo($imageContainer);

        if (productData.thumbnail_type == 'cut-out')
        {
            $mobileSource = jQuery('<source>');
            $mobileSource.attr('media', '(max-width: 1279px)');
            $mobileSource.attr('srcset', '/image/product/' + productData.id + '/thumbnail/cut-out/' + productData.thumbnail_cache_buster + '/' + productData.url_key + '-192x304.jpg');
            $mobileSource.appendTo($picture);

            $desktopSource = jQuery('<source>');
            $desktopSource.attr('media', '(min-width: 1280px)');
            $desktopSource.attr('srcset', '/image/product/' + productData.id + '/thumbnail/cut-out/' + productData.thumbnail_cache_buster + '/' + productData.url_key + '-96x152.jpg');
            $desktopSource.appendTo($picture);

            $image = jQuery('<img>');
            $image.attr('width', 96);
            $image.attr('height', 152);
            $image.attr('src', '/image/product/' + productData.id + '/thumbnail/cut-out/' + productData.thumbnail_cache_buster + '/' + productData.url_key + '-96x152.jpg');
            $image.attr('alt', productData.name);
            $image.attr('important', 'low');
            $image.appendTo($picture);
        }
        else 
        {
            $mobileSource = jQuery('<source>');
            $mobileSource.attr('media', '(max-width: 1279px)');
            $mobileSource.attr('srcset', '/image/product/' + productData.id + '/thumbnail/photo/' + productData.thumbnail_cache_buster + '/' + productData.url_key + '-224x336.jpg');
            $mobileSource.appendTo($picture);

            $desktopSource = jQuery('<source>');
            $desktopSource.attr('media', '(min-width: 1280px)');
            $desktopSource.attr('srcset', '/image/product/' + productData.id + '/thumbnail/photo/' + productData.thumbnail_cache_buster + '/' + productData.url_key + '-112x168.jpg');
            $desktopSource.appendTo($picture);

            $image = jQuery('<img>');
            $image.attr('width', 112);
            $image.attr('height', 168);
            $image.attr('src', '/image/product/' + productData.id + '/thumbnail/photo/' + productData.thumbnail_cache_buster + '/' + productData.url_key + '-112x168.jpg');
            $image.attr('alt', productData.name);
            $image.attr('important', 'low');
            $image.appendTo($picture);
        }

        if (productData.mshop_primary_badge || productData.mshop_secondary_badge)
        {
            $badges = jQuery('<div>');
            $badges.addClass('xmx-product-image-badges');
            $badges.appendTo($imageWrapper);

            if (productData.mshop_primary_badge)
            {
                $badge = jQuery('<div>');
                $badge.addClass('xmx-badge');
                $badge.html(productData.mshop_primary_badge);
                $badge.appendTo($badges);
            }

            if (productData.mshop_secondary_badge)
            {
                $badge = jQuery('<div>');
                $badge.addClass('xmx-badge');
                $badge.addClass('xmx-badge--secondary');
                $badge.html(productData.mshop_secondary_badge);
                $badge.appendTo($badges);
            }
        }

        $text = jQuery('<div>');
        $text.addClass('xmx-mini-product-text');
        $text.appendTo($product);

        $brand = jQuery('<div>');
        $brand.addClass('xmx-subtitle');
        $brand.html(productData.manufacturer);
        $brand.appendTo($text);

        $name = jQuery('<div>');
        $name.addClass('xmx-name');
        $name.addClass('xmx-name--small');
        $name.html(productData.name);
        $name.appendTo($text);

        $shortDescription = jQuery('<div>');
        $shortDescription.addClass('xmx-short-description');
        $shortDescription.addClass('xmx-short-description--small');
        $shortDescription.html(productData.mshop_subtitle ? productData.mshop_subtitle : productData.mshop_type);
        $shortDescription.appendTo($text);

        if (productData.mshop_card_tags)
        {
            if (productData.mshop_card_tags.length > 0)
            {
                $tags = jQuery('<div>');
                $tags.addClass('xmx-tags');
                $tags.appendTo($text);

                for ( tagIndex in productData.mshop_card_tags)
                {
                    $tag = jQuery('<div>');
                    $tag.addClass('xmx-tag');
                    $tag.html(productData.mshop_card_tags[tagIndex]);    
                    $tag.appendTo($tags);
                }
            }
        }

        $price = jQuery('<div>');
        $price.addClass('xmx-price');
        $price.addClass('xmx-price--small');
        $price.appendTo($text);

        if (productData.is_on_sale)
        {
            $oldPrice = jQuery('<div>');
            $oldPrice.addClass('xmx-price-old');
            $oldPrice.html(XmxApp.formatAmount(productData.price));
            $oldPrice.appendTo($price);

            $newPrice = jQuery('<div>');
            $newPrice.addClass('xmx-price-new');
            $newPrice.html(XmxApp.formatAmount(productData.special_price));
            $newPrice.appendTo($price);

             saving = -1 * Math.round(100 - (productData.special_price * 100 / productData.price));

            $discount = jQuery('<div>');
            $discount.addClass('xmx-price-discount');
            $discount.html(saving + '%');
            $discount.appendTo($price);
        }
        else 
        {
            $regularPrice = jQuery('<div>');
            $regularPrice.addClass('xmx-price-regular');
            $regularPrice.html(XmxApp.formatAmount(productData.price));
            $regularPrice.appendTo($price);
        }

        if (productData.base_price_string)
        {
            if (productData.base_price_string != '')
            {
                $basePrice = jQuery('<div>');
                $basePrice.addClass('xmx-price-unit');
                $basePrice.html(productData.base_price_string);
                $basePrice.appendTo($text);
            }
        }

        $product.appendTo($parent);

        // Add Clerk click tracking
        if (XmxApp.supportsClerk())
        {
            Clerk.addClickTracking('#' + elementId);

            $product.attr('data-clerk-hooked', true);
        }
    },

    /**
     * Renders products
     * 
     * @param {array} products 
     * @param {element} $list 
     * @param {element} $container 
     * @param {bool} addViewAllButton
     */
    renderProducts: function(products, $list, $container, addViewAllButton)
    {
        $list.empty();

        if (products)
        {
            for (var productIndex in products)
            {
                this.createProductHtml(products[productIndex], $list);
            }

            if (addViewAllButton)
            {
                var $buttonContainer = jQuery('<div>');
                $buttonContainer.addClass('xmx-mobile-search-button');

                // Add a "see all button"
                var $button = jQuery('<a>');
                $button.addClass('xmx-button');
                $button.addClass('xmx-button--primary');
                $button.addClass('xmx-button--fullwidth');
                $button.attr('href', '/catalogsearch/result?q=' + encodeURIComponent(this.searchQuery));
                $button.appendTo($buttonContainer);

                var $buttonLabel = jQuery('<span>');
                $buttonLabel.addClass('xmx-button-label');
                $buttonLabel.html('Se fler');
                $buttonLabel.appendTo($button);

                $buttonContainer.appendTo($list);
            }

            $container.show();
        }
        else 
        {
            $container.hide();
        }
    }
};
var XmxDesktopHeader = (function()
{
    /**
     * Props
     */
    var _lastScrollOffset = 0;
    var _state = 'default';
    var $_headerElement;

    /**
     * Executed after page load
     */
    function boot()
    {
        $_headerElement = jQuery('#xmx-desktop-header-sticky');

        // Hook the scroll event observer
        XmxApp.registerScrollEventObserver('desktop-menu', handleScroll);

        // And initialize it once
        handleScroll();
    }

    /**
     * Fired inside an animation frame, where supported
     */
    function handleScroll()
    {
        var scrollPosition = XmxApp.scrollOffsetY;

        // Below 121px, it should not be sticky at all and be in default state
        if (scrollPosition <= 121)
        {
            if (_state != 'default')
            {
                _state = 'default';
                $_headerElement.removeClass('xmx-desktop-header-sticky--hidden');
                $_headerElement.removeClass('xmx-desktop-header-sticky--pinned');
            }
        }
        else 
        {
            if (scrollPosition > _lastScrollOffset) 
            {
                // We are scrolling down
                if (_state != 'hidden')
                {
                    _state = 'hidden';
                    $_headerElement.removeClass('xmx-desktop-header-sticky--pinned');
                    $_headerElement.addClass('xmx-desktop-header-sticky--hidden');
                }
            }
            else 
            {
                // We are scrolling up
                if (_state != 'pinned')
                {
                    _state = 'pinned';
                    $_headerElement.removeClass('xmx-desktop-header-sticky--hidden');
                    $_headerElement.addClass('xmx-desktop-header-sticky--pinned');
                }
            }
        }

        _lastScrollOffset = scrollPosition;
    }

    /**
     * Public interface
     */
    return { // line break is not allowed here

        /**
         * Constructor, boots the checkout
         */
        construct: function() 
        {
            boot();
        }
    };
})();

XmxDesktopHeader.construct();

var XmxDesktopSearch = (function()
{
    /**
     * Properties
     */
    var _isSearchOpen = false;
    var _isChangingState = false;
    var _query = '';
    var _lastSubmittedQuery = '';
    var _selectedSuggestionIndex = null;

    /**
     * Elements
     */
    var $_body;
    var $_results;
    var $_form;
    var $_clearButton;
    var $_queryInput;
    var $_suggestionArea;
    var $_suggestionResults;
    var $_categoryArea;
    var $_categoryResults;
    var $_productArea;
    var $_productResults;
    var $_popularQueryArea;
    var $_popularQueryResults;
    var $_trendingProductArea;
    var $_trendingProductResults;
    var $_desktopHeader;
    var $_skrim;

    /**
     * Executed after page load
     */
    function boot()
    {
        $_desktopHeader = jQuery('#desktop-header');

        $_body = jQuery('body');

        $_results = jQuery('#desktop-search-results');

        $_skrim = jQuery('#desktop-search-skrim');
        $_skrim.on('click', onSkrimClick);

        $_form = jQuery('#desktop-search-form');
        $_form.on('submit', onFormSubmit);

        $_clearButton = jQuery('#desktop-search-clear-button');
        $_clearButton.on('click', onClearButtonClick);

        $_queryInput = jQuery('#desktop-search-input');
        $_queryInput.on('focus', onQueryInputFocus);
        $_queryInput.on('change', onQueryInputChange);
        $_queryInput.on('keyup', onQueryInputKeyUp);
        $_queryInput.on('keydown', onQueryInputKeyDown);

        $_suggestionArea = jQuery('#desktop-search-suggestions');
        $_suggestionResults = jQuery('#desktop-search-suggestion-results');

        $_categoryArea = jQuery('#desktop-search-categories');
        $_categoryResults = jQuery('#desktop-search-category-results');

        $_popularQueryArea = jQuery('#desktop-search-popular');
        $_popularQueryResults = jQuery('#desktop-search-popular-results');

        $_productArea = jQuery('#desktop-search-products');
        $_productResults = jQuery('#desktop-search-product-results');

        $_trendingProductArea = jQuery('#desktop-search-trending-products');
        $_trendingProductResults = jQuery('#desktop-search-trending-product-results');

        var query = XmxSearch.peekStoredSearchQuery();

        if (query)
        {
            $_queryInput.val(query);
            $_clearButton.show();
            
            _query = query;
        }
    }

    /**
     * Fired when the user clicked the background skrim
     */
    function onSkrimClick()
    {
        XmxApp.sendGoogleAnalyticsEvent
        (
            'Desktop Search',
            'Clicked Background Skrim',
            null,
            false
        );

        closeSearch();
    }

    /**
     * Fired when the user clicked the clear button
     * 
     * @param {Event} event 
     */
    function onClearButtonClick(event)
    {
        XmxApp.sendGoogleAnalyticsEvent
        (
            'Desktop Search',
            'Clicked Clear Button',
            null,
            false
        );

        $_queryInput.val('');

        updateSearchQuery();

        if (_isSearchOpen)
        {
            // Keep the focus 
            $_queryInput.focus();
        }
        else 
        {
            // Stop propagating through to the input, as this might open
            // the search if you press the clear button in closed state
            event.stopPropagation();
            event.preventDefault();
        }

        // Forget session storage
        XmxSearch.clearSessionStorage();
    }

    /**
     * Fired when the user submits the form
     * 
     * @param {Event} event 
     */
    function onFormSubmit(event)
    {
        var query = $_queryInput.val().trim();

        // If there is no query input, do not suport the form.
        // Focus the input instead.
        if (query == '')
        {
            event.preventDefault();
            event.stopPropagation();

            $_queryInput.focus();
        }
    }

    /**
     * Fired when the user focuses the query input
     */
    function onQueryInputFocus()
    {
        XmxApp.sendGoogleAnalyticsEvent
        (
            'Desktop Search',
            'Opened Search',
            null,
            false
        );

        openSearch();
    }

    /**
     * Fired when the user changed the query input
     */
    function onQueryInputChange()
    {
        updateSearchQuery();
    }

    /**
     * Fired when the user pressed a key in the query input
     * 
     * @param {Event} event 
     */
    function onQueryInputKeyDown(event)
    {
        var key = event.which || event.keyCode;

        // Prevent the caret from jumping around
        if (key == 38 || key == 40) // down / up
        {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    /**
     * Fired when the user pressed a key in the query input
     * 
     * @param {Event} event 
     */
    function onQueryInputKeyUp(event)
    {
        var key = event.which || event.keyCode;

        if (key == 38) // down
        {
            changeSuggestionSelection(-1);
            event.preventDefault();
        }
        else 
        {
            if (key == 40) // up
            {
                changeSuggestionSelection(1);
                event.preventDefault();
            }
            else 
            {
                updateSearchQuery();
            }
        }
    }

    /**
     * 
     * @param {*} direction 
     */
    function changeSuggestionSelection(direction)
    {
        var $results = jQuery('[data-selectable="true"]:visible', $_results);

        $results.removeClass('xmx-search-text-result--selected');

        if ($results.length == 0)
        {
            _selectedSuggestionIndex = null;
            return;
        }

        if (_selectedSuggestionIndex === null)
        {
            if (direction == 1)
            {
                _selectedSuggestionIndex = 0;
            }
            else 
            {
                _selectedSuggestionIndex = $results.length - 1;
            }
        }
        else 
        {
            _selectedSuggestionIndex += direction;
        }

        if (_selectedSuggestionIndex > $results.length - 1)
        {
            _selectedSuggestionIndex = 0;
        }
        else 
        {
            if (_selectedSuggestionIndex < 0)
            {
                _selectedSuggestionIndex = $results.length - 1;
            }
        }

        var $selectedResult = jQuery($results[_selectedSuggestionIndex]);

        $selectedResult.addClass('xmx-search-text-result--selected');

        $_queryInput.val($selectedResult.data('query'));

        $_clearButton.show();
    }

    /**
     * Gets the latest search query from the input and takes action,
     * if required.
     */
    function updateSearchQuery()
    {
        _query = $_queryInput.val();
        _query = _query.toLowerCase();
        _query = _query.trim();

        _selectedSuggestionIndex = null;

        XmxSearch.searchQuery = _query;

        if (_query == '')
        {
            XmxSearch.clearSessionStorage();

            $_clearButton.hide();

            // Show last searches / popular ones + trending products
            XmxSearch.renderQueries(XmxSearch.popularSearchQueries, $_popularQueryResults, $_popularQueryArea, false, 'xmx-icon-search');
            XmxSearch.renderProducts(XmxSearch.trendingProducts, $_trendingProductResults, $_trendingProductArea);

            $_categoryArea.hide();
            $_suggestionArea.hide();
            $_productArea.hide();
        }
        else 
        {
            $_clearButton.show();

            if (_query.length > 2)
            {
                if (_query != _lastSubmittedQuery)
                {
                    search();
                }
            }
        }
    }

    /**
     * Restores the last state
     */
    function retoreState()
    {
        // Restore what can be restored
        XmxSearch.restoreState(); // only executes once

        if (XmxSearch.popularSearchQueries)
        {
            XmxSearch.renderQueries(XmxSearch.popularSearchQueries, $_popularQueryResults, $_popularQueryArea, false, 'xmx-icon-search');
        }
        else 
        { 
            XmxSearch.fetchPopularSearchQueries(function(result)
            {
                if (result && !XmxSearch.searchQuery)
                {
                    XmxSearch.renderQueries(XmxSearch.popularSearchQueries, $_popularQueryResults, $_popularQueryArea, false, 'xmx-icon-search');
                }
                else 
                {
                    $_popularQueryArea.hide();
                }
            });
        }

        if (XmxSearch.trendingProducts)
        {
            XmxSearch.renderProducts(XmxSearch.trendingProducts, $_trendingProductResults, $_trendingProductArea);
        }
        else 
        {
            XmxSearch.fetchTrendingProducts(function(result)
            {
                if (result && !XmxSearch.searchQuery)
                {
                    XmxSearch.renderProducts(XmxSearch.trendingProducts, $_trendingProductResults, $_trendingProductArea);
                }
                else 
                {
                    $_trendingProductArea.hide();
                }
            });
        }

        if (XmxSearch.searchQuery)
        {
            _query = XmxSearch.searchQuery;

            $_queryInput.val(XmxSearch.searchQuery);
            $_clearButton.show();

            if (XmxSearch.categories)
            {
                XmxSearch.renderCategories(XmxSearch.categories, $_categoryResults, $_categoryArea);
            }
            else 
            {
                $_categoryArea.hide();
            }

            if (XmxSearch.suggestedSearchQueries)
            {
                XmxSearch.renderQueries(XmxSearch.suggestedSearchQueries, $_suggestionResults, $_suggestionArea, true, 'xmx-icon-search');
            }
            else 
            {
                $_suggestionArea.hide();
            }

            if (XmxSearch.products)
            {
                XmxSearch.renderProducts(XmxSearch.products, $_productResults, $_productArea, false);
            }
            else 
            {
                $_productArea.hide();
            }

            $_trendingProductArea.hide();
            $_popularQueryArea.hide();
        }
    }

    /**
     * Opens the search
     */
    function openSearch()
    {
        if (_isSearchOpen || _isChangingState)
        {
            return;
        }

        retoreState();

        if (!XmxSearch.products)
        {
            $_productArea.hide();
        }

        if (!XmxSearch.suggestedSearchQueries)
        {
            $_suggestionArea.hide();
        }

        if (!XmxSearch.categories)
        {
            $_categoryArea.hide();
        }

        _isChangingState = true;

        $_body.addClass('xmx-body--prevent-scrolling');

        $_desktopHeader.addClass('xmx-desktop-header--search-visible');
        $_desktopHeader.offset(); // Force reflow
        $_desktopHeader.addClass('xmx-desktop-header--search-open');

        setTimeout(function() 
        {
            _isSearchOpen = true;
            _isChangingState = false;
        }, 375);
    }

    /**
     * Closes the mobile search
     */
    function closeSearch()
    {
        if (!_isSearchOpen || _isChangingState)
        {
            return;
        }

        _isChangingState = true;

        $_body.removeClass('xmx-body--prevent-scrolling');
        $_desktopHeader.removeClass('xmx-desktop-header--search-open');

        setTimeout(function() 
        {
            _isSearchOpen = false;
            _isChangingState = false;

            $_desktopHeader.removeClass('xmx-desktop-header--search-visible');
        }, 250);
    }

    /**
     * Calls Clerk and does things and stuff :)
     */
    function search()
    {
        // Remember the last search query
        XmxSearch.saveSearchQuery(_query);

        $_trendingProductArea.hide();
        $_popularQueryArea.hide();

        fetchSuggestions();
        fetchCategories();
        fetchProducts();

        _lastSubmittedQuery = _query;
    }

    /**
     * Downloads and renders suggestions
     */
    function fetchSuggestions()
    {
        XmxSearch.fetchSuggestedSearchQueries(_query, function(result)
        {
            if (result)
            {
                XmxSearch.renderQueries(result, $_suggestionResults, $_suggestionArea, true, 'xmx-icon-search');
            }
            else 
            {
                $_suggestionArea.hide();
            }
        });
    }

    /**
     * Downloads and renders categories
     */
    function fetchCategories()
    {
        XmxSearch.fetchCategories(_query, function(result)
        {
            if (result)
            {
                XmxSearch.renderCategories(result, $_categoryResults, $_categoryArea);
            }
            else 
            {
                $_categoryArea.hide();
            }
        });
    }

    /**
     * Downloads and renders categories
     */
    function fetchProducts()
    {
        XmxSearch.fetchProducts(_query, function(result)
        {
            if (result)
            {
                XmxSearch.renderProducts(result, $_productResults, $_productArea, false);
            }
            else 
            {
                $_productArea.hide();
            }
        });
    }

    /**
     * Public interface
     */
    return { // line break is not allowed here

        /**
         * Constructor, boots the checkout
         */
        construct: function() 
        {
            boot();
        },

        isOpen: function()
        {
            return _isSearchOpen;
        }
    };
})();

XmxDesktopSearch.construct();

(function($, window, document) 
{
    /**
     * Plugin Name
     */
    var pluginName = "naeAddToCart";

    /**
     * Default Options
     */
    var defaultOptions = {};

    /**
     * Constructor
     */
    function Plugin(element, options) 
    {
        this.element = jQuery(element);
        this.options = jQuery.extend({}, defaultOptions, options);
        this.name = pluginName;
        this.submitButtonElement = jQuery('button[type="submit"]', this.element);
        this.popupIsVisible = false;
        this.powerstep = jQuery('#powerstep');
        this.popupBackground = jQuery('#powerstep-popup-background');
        this.closePopupButton = jQuery('#powerstep-popup-close-button');
        this.popup = jQuery('#powerstep-popup');
        this.body = jQuery('body');
        this.itemImage = jQuery('#powerstep-popup-item-image');
        this.itemName = jQuery('#powerstep-popup-item-name');
        this.itemPrice = jQuery('#powerstep-popup-item-price');
        this.crossSelling = jQuery('#powerstep-popup-cross-selling');
        this.crossSellingItems = jQuery('#powerstep-cross-selling-items');
        this.cartButton = jQuery('#powerstep-popup-cart-button');

        this.init();
    }

    /**
     * Methods
     */
    Plugin.prototype = 
    {
        /**
         * The page has been loaded and we can start working now
         */
        init: function()
        {
            var me = this;

            // The add to basket button is disabled on product pages,
            // as we needed to wait for the JS to load for it to 
            // function. Enable it now.
            if (jQuery('body').hasClass('catalog-product-view'))
            {
                me.submitButtonElement.prop('disabled', false);
            }

            // The user has clicked on the background. Close the popup.
            // Need to do it this way to not lose scope/this
            me.popupBackground.on('click', function(event)
            {
                me.closePopup(event);
            });

            // The user has clicked on the "close button". Close the popup.
            // Need to do it this way to not lose scope/this
            me.closePopupButton.on('click', function(event)
            {
                me.closePopup(event);
            });

            // The user has clicked on "Go to Shopping Cart"
            me.cartButton.on('click', function(event)
            {
                return me.goToShoppingCart(event);
            });

            // Customer has clicked the button or managed to submit
            // form the form in another way
            me.element.on('submit', function(event)
            {
                me.addItemToCart(event);
            });
        },

        addItemToCart: function(event)
        { 
            var me = this;

            // Disable the button
            me.submitButtonElement.prop('disabled', true);

            // Show AJAX loader
            me.submitButtonElement.addClass('xmx-button--loading');

            // Fire AJAX
            jQuery.ajax
            ({
                url: me.element.attr('action'),
                dataType: 'json',
                type : 'post',
                data: me.element.serialize(),

                success: function(response)
                {
                    if (response.hasError)
                    {
                        var $error = jQuery('#add-to-cart-error');
                        $error.html(response.errorMessage);
                        $error.addClass('xmx-message--visible');
                    }
                    else
                    {
                        jQuery('#desktop-header-shopping-cart').replaceWith(response.cartSidebar);

                        var $regularMobileHeader = jQuery('#mobile-header');
                        jQuery('.xmx-mobile-shopping-cart-button-empty', $regularMobileHeader).hide();
                        jQuery('.xmx-mobile-shopping-cart-button-filled', $regularMobileHeader).show();
                        jQuery('.xmx-mobile-header-shopping-cart-button', $regularMobileHeader).attr('data-has-items', true);
                        jQuery('.xmx-mobile-shopping-cart-quantity', $regularMobileHeader).show().html(response.cartQuantity);

                        var $stickyMobileHeader = jQuery('#mobile-header-sticky');
                        jQuery('.xmx-mobile-shopping-cart-button-empty', $stickyMobileHeader).hide();
                        jQuery('.xmx-mobile-shopping-cart-button-filled', $stickyMobileHeader).show();
                        jQuery('.xmx-mobile-header-shopping-cart-button', $stickyMobileHeader).attr('data-has-items', true);
                        jQuery('.xmx-mobile-shopping-cart-quantity', $stickyMobileHeader).show().html(response.cartQuantity);

                        // Tell Google, if Google Analytics is there already
                        if (typeof ga !== 'undefined')
                        {
                            ga('ec:addProduct', response.google);
                            ga('ec:setAction', 'add');
                            ga('send', 'event', 'UX', 'Powerstep Pop-up', 'Added Item to Cart');
                        }

                        // Update image, name, price
                        me.itemImage.attr('src', response.summary.image);
                        me.itemName.html(response.summary.name);
                        me.itemPrice.html(response.summary.finalPrice + ' kr'); // very basic for now

                        // Exclude these products. Exclude what is in the custom options already, if
                        // on a PDP
                        var exclude = response.summary.clerkExclude;

                        if (typeof window.naeProductConfiguration !== 'undefined')
                        {
                            var productConfig = window.naeProductConfiguration;

                            if (productConfig.complementaryProducts)
                            {
                                for (var productIndex in productConfig.complementaryProducts)
                                {
                                    if (exclude != '')
                                    {
                                        exclude += ', ';
                                    }

                                    exclude += productConfig.complementaryProducts[productIndex].productId;
                                }
                            }
                        }

                        // Update Clerk IDs
                        me.crossSellingItems.attr('data-products', '[' + response.summary.clerkProducts + ']');
                        me.crossSellingItems.attr('data-exclude', '[' + exclude + ']');
                        me.crossSellingItems.attr('data-filter', response.summary.clerkFilter);

                        // Delete existing Clerk sliders, as they are going to be rebuild
                        jQuery('.xmx-carousel', me.crossSelling).remove();

                        // If Clerk is ready, show cross selling.
                        // If not, hide the Clerk area
                        if (typeof Clerk !== 'undefined')
                        {
                            // Ensure the cross selling-section is visible
                            me.crossSelling.show();

                            // Have Clerk.js create and render the recommendation
                            Clerk.renderBlocks('#powerstep-cross-selling-items')
                        }
                        else 
                        {
                            // Clerk is not defined yet, so hide the cross-selling, 
                            // since we cannot render it yet
                            me.crossSelling.hide();
                        }

                        // Remember the popup is open
                        me.popupIsVisible = true;

                        // Disable scrolling
                        me.body.addClass('xmx-body--prevent-scrolling');
                        me.body.offset(); // Force reflow

                        me.powerstep.addClass('xmx-powerstep--visible');
                        me.powerstep.offset(); // Force reflow
                        me.powerstep.addClass('xmx-powerstep--open');
                    }
                },

                complete: function()
                {
                    // Enable le button
                    me.submitButtonElement.prop('disabled', false);
                    me.submitButtonElement.removeClass('xmx-button--loading');
                }
            });

            // Do not submit the form
            event.preventDefault();
            event.stopPropagation();
        },

        closePopup: function(event)
        {
            var me = this;

            if (me.popupIsVisible)
            {
                me.popupIsVisible = false;

                // Tell Google
                if (typeof ga !== 'undefined')
                {
                    ga('send', 'event', 'UX', 'Powerstep Pop-up', 'Closed Pop-up');
                }
                
                me.powerstep.removeClass('xmx-powerstep--open');

                setTimeout(function() 
                {
                    me.powerstep.removeClass('xmx-powerstep--visible');
                    me.body.removeClass('xmx-body--prevent-scrolling');
                }, 200);

                // No bubbling, in case of multiple add to cart plugins hooked, like on top lists
                event.preventDefault();
                event.stopPropagation();
            }
        },

        goToShoppingCart: function(event)
        {
            var redirectTimeoutHandle;

            if (typeof ga !== 'undefined')
            {
                // If Google Analytics is loaded, send an event to Google and
                // then redirect the customer to the shopping cart. If Google
                // does not respond within a second, just go to the shopping cart
                redirectTimeoutHandle = setTimeout
                (
                    function()
                    {
                        document.location = '/checkout/cart';
                    }, 
                    1000
                );

                ga('send', 'event', 'UX', 'Powerstep Pop-up', 'Went to Shopping Cart',
                {
                    hitCallback: function()
                    {
                        // Cancel timeout
                        clearTimeout(redirectTimeoutHandle);

                        // Redirect customer
                        document.location = '/checkout/cart';
                    }
                });
            }
            else 
            {
                // If Google Analytics is not loaded, forward the customer
                // to the shopping cart directly
                document.location = '/checkout/cart';
            }

            event.preventDefault();
            event.stopPropagation();

            return false;
        }
    };

    /**
     * Registration
     */
    jQuery.fn[pluginName] = function(options) 
    {
        var instance = null;

        return this.each(function() 
        {
            instance = jQuery.data(this, pluginName);

            if (!instance)
            {
                jQuery.data(this, pluginName, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);

jQuery('form[data-add-to-cart-form]').naeAddToCart();

